import { memo } from "react";
import { Chip, Tooltip } from "@mui/material";
import { SupportAgent } from "@mui/icons-material";
import {
  isTeleconsultoriaAvailabilitySchedule,
  isTeleconsultoriaSchedule,
} from "../../utils/actors";

/**
 * Selo "Teleconsultoria" do cabeçalho de agenda (Gerenciar agenda, legado).
 * Complementa o ícone de tipo de atendimento: a agenda de teleconsultoria usa
 * Location virtual e, sem o selo, parece um teleatendimento comum.
 */
export const TeleconsultoriaScheduleBadge = memo(function TeleconsultoriaScheduleBadge({
  schedule,
}: {
  schedule: fhir5.Schedule | undefined;
}) {
  if (!isTeleconsultoriaSchedule(schedule)) return null;

  // Sem Location = só disponibilidade (switch "Disponível"); com Location = agenda com horários.
  const tooltip = isTeleconsultoriaAvailabilitySchedule(schedule)
    ? "Disponibilidade para convites de teleconsultoria"
    : "Agenda de teleconsultoria — horários oferecidos às clínicas afiliadas";

  return (
    <Tooltip title={tooltip}>
      <Chip
        size="small"
        icon={<SupportAgent />}
        label="Teleconsultoria"
        aria-label={tooltip}
        sx={{
          flexShrink: 0,
          fontWeight: 600,
          backgroundColor: "success100.main",
          color: "success700.main",
          "& .MuiChip-icon": { color: "success700.main" },
        }}
      />
    </Tooltip>
  );
});
